export const FETCH_START = 'overlays/FETCH_START'
export const FETCH_SUCCESS = 'overlays/FETCH_SUCCESS'
export const FETCH_FAILURE = 'overlays/FETCH_FAILURE'

export const TOGGLE = 'overlays/TOGGLE'
